// extracted by mini-css-extract-plugin
export default {"container":"dztna","infoContainer":"s1JWI","rowAndSeat":"OS4U7","ticketInfoContainer":"S+j0T"};